import { createFileRoute } from "@tanstack/react-router";
import { QueueDashboardPage } from "@client/components/settings/job-manager/queue-dashboard-page";

export type JobManagerTab = "schedules" | "tasks" | "workers";

export interface JobManagerSearch {
  /** 宽化为 string 透传子路由（任务详情 tab=detail|logs），避免父级清洗后子级回落默认值 */
  tab?: string;
  /** Worker 节点 tab 内选中的 workerId（?tab=workers&worker=xxx 直达详情视图） */
  worker?: string;
}

export const Route = createFileRoute("/_app/settings/job-manager")({
  validateSearch: (search: Record<string, unknown>): JobManagerSearch => ({
    tab: typeof search.tab === "string" ? search.tab : undefined,
    worker: typeof search.worker === "string" ? search.worker : undefined,
  }),
  component: QueueDashboardPage,
});
